import React from 'react';
import { cn } from '@/lib/utils';

/**
 * The single outer content width for every public page.
 *
 * Pages may still nest a narrower measure inside it — long-form prose reads
 * better at ~65 characters — but the outer shell always matches the header and
 * footer.
 *
 * The header and footer used `max-w-7xl px-6 lg:px-8` while the landing page
 * used `max-w-[1240px] px-6`, so the shell never lined up with the content it
 * framed — the misalignment grew at the `lg` breakpoint. One component now owns
 * that measurement.
 */
export function PublicContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn('mx-auto w-full max-w-[1240px] px-6', className)}>{children}</div>;
}
